<div class="container mt-4">
  <div class="form-group">
    <label>Short Code</label>
    <input class="form-control" [(ngModel)]="shortcode" [readonly]="isEditMode" />
  </div>
  <div class="form-group">
    <label>Description</label>
    <input class="form-control" [(ngModel)]="description" />
  </div>
  <div class="form-group">
    <label>Remarks</label>
    <input class="form-control" [(ngModel)]="LayoutRemarks" />
  </div>
  <div class="form-check" *ngIf="!isEditMode">
    <input class="form-check-input" type="checkbox" [(ngModel)]="useExistingLines" />
    <label class="form-check-label">Use layout lines from existing layout</label>
  </div>
  <div class="form-group" *ngIf="useExistingLines && !isEditMode">
    <label>Select Layout</label>
    <select class="form-control" [(ngModel)]="selectedCustomLayout">
      <option value="">-- Select layout --</option>
      <option *ngFor="let customLayout of customLayouts" [value]="customLayout.LayoutShortCode">
        {{ customLayout.LayoutShortCode }} — {{ customLayout.LayoutDescription }}
      </option>
    </select>
  </div>
  <button class="btn btn-success" (click)="saveLayout()">Save</button>
</div>
